/* eslint-disable @typescript-eslint/no-unused-vars */
import { tabTypeToPart } from "../../tab/utils";
export const ROOT_VIEW = null;
export const createAndSetViewInfo = (flexibleLayoutLeaf, blockStartWidgets, renderedWidgets) => {
    let selectedWidgetId = flexibleLayoutLeaf.selectedWidgetId;
    const viewId = flexibleLayoutLeaf.id;
    const viewType = flexibleLayoutLeaf.viewType;
    const widgets = flexibleLayoutLeaf.widgets;
    if (viewType === "blockStart") {
        // Add the widgets to the blockStart section
        widgets.forEach(widget => {
            blockStartWidgets.add(widget.id);
        });
        return {
            id: viewId,
            type: viewType,
            exportParts: "",
            widgets: widgets
        };
    }
    const exportParts = tabTypeToPart[viewType](widgets);
    widgets.forEach(widget => {
        if (widget.wasRendered || selectedWidgetId === widget.id) {
            // Ensure proper initialization
            widget.wasRendered = true;
            renderedWidgets.add(widget.id);
        }
    });
    // If there is no widget selected by default, select one
    if (selectedWidgetId == null) {
        const selectedWidget = widgets[viewType === "main" || viewType === "blockEnd" ? widgets.length - 1 : 0];
        selectedWidgetId = selectedWidget.id;
        selectedWidget.wasRendered = true;
        renderedWidgets.add(selectedWidgetId);
    }
    return {
        id: viewId,
        exportParts,
        selectedWidgetId: selectedWidgetId,
        type: viewType,
        widgets: widgets
    };
};
const addCustomBehavior = (item, layoutSplitterParts) => {
    if (item.dragBar?.part) {
        layoutSplitterParts.add(item.dragBar?.part);
    }
};
const updateFlexibleSubModels = (flexibleLayoutItems, itemsInfo, blockStartWidgets, layoutSplitterParts, renderedWidgets, parentItem) => {
    flexibleLayoutItems.forEach(flexibleItem => {
        // Group
        if (flexibleItem.items != null) {
            const group = flexibleItem;
            const flexibleItemExtended = {
                item: group,
                parentItem: parentItem
            };
            itemsInfo.set(group.id, flexibleItemExtended);
            updateFlexibleSubModels(group.items, // Subitems
            itemsInfo, blockStartWidgets, layoutSplitterParts, renderedWidgets, group);
        }
        // Leaf
        else {
            const leaf = flexibleItem;
            const flexibleItemExtended = {
                item: leaf,
                parentItem: parentItem,
                view: createAndSetViewInfo(leaf, blockStartWidgets, renderedWidgets)
            };
            itemsInfo.set(leaf.id, flexibleItemExtended);
        }
        // Custom behaviors
        addCustomBehavior(flexibleItem, layoutSplitterParts);
    });
};
export const updateFlexibleModels = (flexibleLayout, itemsInfo, blockStartWidgets, layoutSplitterParts, renderedWidgets) => updateFlexibleSubModels(flexibleLayout.items, itemsInfo, blockStartWidgets, layoutSplitterParts, renderedWidgets, ROOT_VIEW // Root item
);
export const getViewInfo = (itemsInfo, viewId) => itemsInfo.get(viewId)
    .view;
//# sourceMappingURL=utils.js.map
